import { IColumn } from '@repo/ui';
import { useLegends } from 'presentation/app/hooks/useLegends';

export const makeAppRegisteredStudentsPerGroupColumns = (): IColumn[] => {
  const { getLegends } = useLegends();

  return [
    {
      title: getLegends('GRUPO', false),
      dataKey: 'group',
      width: 600,
    },
    {
      title: 'Código',
      dataKey: 'code',
    },
    {
      title: 'Cadastros',
      dataKey: 'registrations',
    },
  ];
};
